module.exports = __webpack_public_path__ + "static/nosotros-black-89196daf3c752574ecb1e81d6fd437f1.png";